import { useCallback } from "react";
import {
  MelcoModelsUser,
  UserManagementApi,
  useAPIAction,
} from "melco-shared-logic";

export const useUpdateUserProfile = () => {

  const [UpdateUserProfile] = useAPIAction(
    UserManagementApi,
    async (api, userEditObj: MelcoModelsUser) => {
      //debugger; console.log(userEditObj)

      const data = await api.userEdit({
        id: userEditObj?.id ?? "",
        melcoModelsUser: userEditObj,
      });

      return {
        successMessages: [{ message: "default" }],
        data,
      };
    },
    { skipErrorHandling: true, translationPrefix: "users.actions.update" }
  );

  return useCallback(
    async (userEditObj: MelcoModelsUser) => {
      return await UpdateUserProfile(userEditObj);
    },
    [UpdateUserProfile]
  );
};
